<template>
    <div style="margin: 0; padding: 0; width: 100%;">
        <!-- Sticky title matching My Task style -->
        <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0;">
            <h2 class="pt-3 pb-2" style="letter-spacing:normal;"> {{$t('pmselfservice.kpirecords')}}</h2>
        </div>
        <!-- Loop through KPIList-->
        <v-container fluid class="pa-0 pb-6">
            <v-row dense>
                <v-col
                v-for="(kpi, index) in KPIList"
                :key="index"
                :cols="colSize"
                >
                <v-card outlined elevation="2" class="kpi-record-card">
                    <!-- Status badge top-right -->
                    <div class="status-badge" :class="statusClass(kpi.status)">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;">
                            <circle cx="12" cy="12" r="10"/>
                            <polyline v-if="kpi.status === 'OPEN'" points="12 8 12 12 14 14"/>
                            <polyline v-else points="20 6 9 17 4 12"/>
                        </svg>
                        {{ kpi.status }}
                    </div>

                    <div class="kpi-card-body">
                        <div class="kpi-title mb-1">{{ kpi.title }}</div>
                        <div class="kpi-desc mb-1">{{ kpi.description }}</div>
                        <div class="kpi-meta mb-1"><b>{{ kpi.startdate }}</b> {{$t('until')}} <b>{{ kpi.enddate }}</b></div>
                        <div class="kpi-meta mb-1">{{$t('appraisalrecord.reviewer')}}: <b>{{ kpi.reviewername }}</b></div>
                    </div>

                    <v-card-actions class="justify-end pt-0">
                        <v-btn color="primary" small @click="viewDetails(kpi)">
                            {{$t('pmmoderation.viewdetails')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

import moment from 'moment';

export default {
    data() {
        return {
            KPIList: [],
        };
    },

    computed: {
        colSize() {
            const count = this.KPIList.length;
            if (count === 1) return 12;  // full row
            if (count === 2) return 6;   // half row each
            return 4;                    // 3 per row
        }
    },

    methods: {
        chunkArray(array, size) {
            const chunks = [];
            for (let i = 0; i < array.length; i += size) {
                chunks.push(array.slice(i, i + size));
            }
            return chunks;
        },
        viewDetails(kpi) {
            console.log("KPI: ", kpi);
            this.$router.push({ name: "selfservicekpidetails", params: { kpi : kpi} });
        },

        statusClass(status) {
            if (!status) return 'status-default';
            const s = status.toUpperCase();
            if (s === 'OPEN') return 'status-open';
            if (s === 'COMPLETED') return 'status-completed';
            if (s === 'LOCKED') return 'status-locked';
            return 'status-default';
        },

        loadKPIList() {
            const vm = this;
            this.$store.dispatch('get', {url: "/kpiexercise/staff/list/" + this.$store.getters.staffId})
            .then(function (res) {
                for (let i = 0; i < res.data.rec.length; i++) {
                    if (res.data.rec[i].startdate) {
                        res.data.rec[i].startdate = moment(res.data.rec[i].startdate).format('DD-MM-YYYY');
                    }
                    if (res.data.rec[i].enddate) {
                        res.data.rec[i].enddate = moment(res.data.rec[i].enddate).format('DD-MM-YYYY');
                    }
                }
                vm.KPIList = res.data.rec;
                console.log("KPI List: ", vm.KPIList);
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },
    },

    watch: {
        '$store.getters.staffId'(newId) {
            if (newId) this.loadKPIList();
        },
    },

    mounted() {
        this.loadKPIList();
        console.log("ID: ", this.$store.getters.staffId);
        console.log("INFO", this.$store.getters);
    },    
};

</script>

<style scoped>
.kpi-record-card {
    position: relative;
    color: #1a3a5c;
    margin-bottom: 8px;
}

.kpi-card-body {
    padding: 40px 16px 4px 16px;
}

.status-badge {
    position: absolute;
    top: 10px;
    right: 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    padding: 3px 8px;
    border-radius: 20px;
}

.status-open {
    background: #DCFCE7;
    color: #15803D;
    border: 1px solid #BBF7D0;
}

.status-completed {
    background: #DBEAFE;
    color: #1D4ED8;
    border: 1px solid #BFDBFE;
}

.status-locked {
    background: #FEE2E2;
    color: #B91C1C;
    border: 1px solid #FECACA;
}

.status-default {
    background: #F1F5F9;
    color: #475569;
    border: 1px solid #E2E8F0;
}

.kpi-title {
    font-size: 0.82rem;
    font-weight: 700;
    color: #1a3a5c;
    letter-spacing: normal;
    line-height: 1.4;
}

.kpi-desc {
    font-size: 0.82rem;
    font-weight: 400;
    color: #546e7a;
    letter-spacing: normal;
    line-height: 1.4;
}

.kpi-meta {
    font-size: 0.82rem;
    color: #546e7a;
    letter-spacing: normal;
    line-height: 1.4;
}
</style>